
import React, { useState, useRef, useEffect } from 'react';
import {
  TextField, Button, InputLabel, MenuItem, FormControl, Select, Box, FormHelperText, Autocomplete, InputAdornment, IconButton
} from '@mui/material';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import UserRegisteredSuccessfullyModal from '../../../components/Modals/UserRegisteredSuccessfullyModal';

const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
const allDigitsSame = value => /^(.)\1+$/.test(value);
export const REFERRED_BY_DETAILS_VALIDATIONS = yup.object().shape({
  referredName: yup.string()
    // .required('Name cannot be empty.')
    .matches(/^[a-zA-Z ]*$/, 'Name must contain only alphabets and spaces.'),
  referredCompanyName: yup.string()
  // .required('Company Name cannot be empty.')
  .test('english-characters-only', 'Please enter English characters only', (value) => !value || !nonEngChar.test(value)),
  referredEmail:  yup.string()
  // .required('Email is required.')
  .matches(
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
    'Invalid email format. Example: example@example.com'
  )
  .max(255, 'Email must be at most 255 characters long.'),
  referredPhone: yup.string()
  // .required('Phone number is required.')
  .matches(/^[0-9]+$/, 'Phone number must only contain digits.')
  .test('notAllDigitsSame', 'All digits cannot be the same.', value => !allDigitsSame(value)),
})
const ReferredBy = ({ onSubmit, handleStepChange, currentStep , registersuccessModalopen , handleRegisterSuccessOpen , handleRegisterSuccessClose }) => {

  const navigate = useNavigate();
  // const [modalOpen, setModalOpen] = useState(false);
  //   const [UserRegister, setUserRegister] = useState(false);

  const initialState = {
    referredName: '',
    referredCompanyName: '',
    referredEmail: '',
    referredPhone: '',
  }
  useEffect(() => {
    console.log('REFERRED BY MODAL OPEN',registersuccessModalopen)
  },[registersuccessModalopen])
  const { loading } = useSelector((state) => state.auth);
  return (
    <>
    <Formik

      initialValues={initialState}
      enableReinitialize={true}
      // validationSchema={REFERRED_BY_DETAILS_VALIDATIONS}
      onSubmit={(values, { setSubmitting }) => {
        const formattedValues = {
          ...values,
        };
        // console.log('Formatted Submit:', formattedValues);

        // console.log(values, "value before ")
        // setUserRegister(true)
        onSubmit(formattedValues);

        setSubmitting(false);
      }}
    >
      {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched }) => (
        <form onSubmit={handleSubmit}>

          <Box sx={{ display: 'flex', gap: 2 }}></Box>
          <div className="row">
            {/* <Box sx={{ display: 'flex', gap: 2 }}> */}

            <div className="col-md-6 cs-form mb-3">
              <TextField
                label='Name'
                className='md-input'
                name='referredName'
                value={values.referredName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.referredName}
                helperText={errors.referredName}
              />

            </div>

            <div className="col-md-6 cs-form mb-3 ">
              <TextField
                label='Company'
                className='md-input'
                name='referredCompanyName'
                value={values.referredCompanyName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.referredCompanyName}
                helperText={errors.referredCompanyName}
              />

            </div>
            {/* </Box> */}
            <div className="col-md-6 cs-form mb-3">
              <TextField
                label='Email'
                className='md-input'
                name='referredEmail'
                value={values.referredEmail}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.referredEmail}
                helperText={errors.referredEmail}
              />
            </div>
            <div className="col-md-6 cs-form mb-3">
              <TextField
                label='Phone'
                className='md-input'
                name='referredPhone'
                value={values.referredPhone}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.referredPhone}
                helperText={errors.referredPhone}
              />
            </div>

            <div className="d-flex justify-content-between mt-3">
              <button type="button" className="btn btn-light grey-btn lg-btn" 
              onClick={() => handleStepChange(currentStep - 1)}>
                Back
              </button>
              <div>

              <button type="submit" className="btn btn-primary greeen-btn lg-btn lg-btn" 
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={loading}>
          {loading ? 'Submitting...' : 'Submit'}

                  </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
    
      </>
  )
}


export default ReferredBy
